<template>
	<div class="card">
		<h1>{{$t('PlayerCareerChartTitle')}}</h1>
		<vue-apex-charts v-if="chartGenerated" ref="playerCareerChart" type="line" height="305" :options="chartOptions" :series="series"></vue-apex-charts>
		<div v-else class="error-box">
			{{$t('PlayerChartError')}}
		</div>
	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import CommonService from "@/service/CommonService";
import EnumService from "@/service/EnumService";
import PlayerService from "@/service/PlayerService";
import logoSerieA from "@/assets/images/logos/serieA.png";
import logoSerieB from "@/assets/images/logos/serieB.png";
import logoSerieC from "@/assets/images/logos/serieC.png";
import logoSerieD from "@/assets/images/logos/serieD.png";
import logoLND from "@/assets/images/logos/lnd.png";
import logoPrimavera from "@/assets/images/logos/primavera.png";
import logoSettoreGiovanile from "@/assets/images/logos/settoreGiovanile.png";

export default {
	components: {
		VueApexCharts
	},
	props: ["playerData", "isTransferPlayer"],
	data: function() {
		return {
			xAxisLabels: null,
			series: [],
			chartOptions: null,
			annotations_xaxis_x: null,
			annotations_xaxis_x2: null,
			graphRows: [],
			points: [],
			y_min: 0,
			y_max: 0,
			y_max_offset: 0.1,
			y_experiences_tag: 0,
			numberExperiencies: 1,
			playerAge: null,
			chartGenerated: false
		};
	},
	playerService: null,
	commonService: null,
	enumService: null,
	created() {
		let self = this;
		this.playerService = new PlayerService();
		this.commonService = new CommonService();
		this.enumService = new EnumService();

		this.generateChart();

		if (window.innerWidth <= 700) {
			// zoom in just for mobiles
			var observer = new MutationObserver(function(mutations) {
				if (
					document.contains(
						self.$refs.playerCareerChart.chart.toolbar.elZoomIn
					)
				) {
					self.zoomInChart();
					observer.disconnect();
				}
			});

			observer.observe(document, {
				attributes: false,
				childList: true,
				characterData: false,
				subtree: true
			});
		}
	},
	methods: {
		zoomInChart() {
			function eventFire(el, etype) {
				if (el.fireEvent) {
					el.fireEvent("on" + etype);
				} else {
					var evObj = document.createEvent("Events");
					evObj.initEvent(etype, true, false);
					el.dispatchEvent(evObj);
				}
			}

			eventFire(
				this.$refs.playerCareerChart.chart.toolbar.elZoomIn,
				"click"
			);
		},
		generateChart: function() {
			function generateXAxisLabels() {
				self.xAxisLabels = [];

				// previous years
				var endYear =
					self.playerData.Experiences[self.numberExperiencies - 1]
						.Season.StartYear +
					1 -
					3;
				var startYear = endYear - 1;
				self.xAxisLabels.push(startYear++ + "/" + (endYear++ % 100));
				self.xAxisLabels.push(startYear++ + "/" + endYear++) % 100;
				self.xAxisLabels.push(startYear + "/" + (endYear % 100));

				// experiences years
				var previousStartYear = 0;
				var postfix = 2;
				var seasonLabel = "";
				var j = 0;
				for (var i = self.numberExperiencies - 1; i >= 0; i--) {
					if (
						previousStartYear ==
						self.playerData.Experiences[i].Season.StartYear
					) {
						seasonLabel =
							self.playerData.Experiences[i].Season.StartYear +
							"/" +
							(self.playerData.Experiences[i].Season.EndYear %
								100) +
							" (" +
							postfix +
							"°)";
						postfix++;
					} else {
						seasonLabel =
							self.playerData.Experiences[i].Season.StartYear +
							"/" +
							(self.playerData.Experiences[i].Season.EndYear %
								100);
						postfix = 2;
					}
					if (j == 0) self.annotations_xaxis_x = seasonLabel;
					else if (j == 2) self.annotations_xaxis_x2 = seasonLabel;
					self.xAxisLabels.push(seasonLabel);
					previousStartYear =
						self.playerData.Experiences[i].Season.StartYear;
					j++;
				}

				// future years
				endYear = self.playerData.Experiences[0].Season.EndYear + 1;
				startYear = self.playerData.Experiences[0].Season.StartYear + 1;
				self.xAxisLabels.push(startYear++ + "/" + (endYear++ % 100));
				self.xAxisLabels.push(startYear++ + "/" + (endYear++ % 100));
				self.xAxisLabels.push(startYear + "/" + (endYear % 100));
			}
			function generateSeries() {
				self.series = [
					{
						name: "simulated past",
						data: [
							self.graphRows[0].categoryCoeff,
							self.graphRows[1].categoryCoeff,
							self.graphRows[2].categoryCoeff,
							self.graphRows[3].categoryCoeff,
							null,
							null,
							null,
							null,
							null
						]
					},
					{
						name: "experiences",
						data: [
							null,
							null,
							null,
							self.graphRows[3].categoryCoeff,
							self.graphRows[4].categoryCoeff,
							self.graphRows[5].categoryCoeff,
							null,
							null,
							null
						]
					},
					{
						name: "simulated future",
						data: [
							null,
							null,
							null,
							null,
							null,
							self.graphRows[5].categoryCoeff,
							self.graphRows[6].categoryCoeff,
							self.graphRows[7].categoryCoeff,
							self.graphRows[8].categoryCoeff
						]
					}
				];
			}
			function getPreviousFirstTeamCategory(category, age) {
				if (self.isTransferPlayer) {
					if (age <= 20) return 15;
					else if (category == 0) return 0;
					else return category + 1;
				} else {
					switch (category) {
						case 0: // serie A
							return 0;
						case 2: // serie C
							return 6;
						case 1: // serie B
						case 6: // serie D
						case 7: // Eccellenza
						case 8: // Promozione
						case 9: // PrimaCategoria
						case 10: // SecondaCategoria
							return category + 1;
						case 11: // TerzaCategoria
							if (age <= 20) return category + 1;
							// jump to juniores
							else return category;
						default:
							return 11;
					}
				}
			}
			function getFutureFirstTeamCategory(category) {
				if (self.isTransferPlayer) {
					if (category == 0) return 0;
					else return category - 1;
				} else {
					switch (category) {
						case 0: // serie A
							return 0;
						case 6: // serie D
							return 2;
						case 2: // serie C
						case 1: // serie B
						case 7: // Eccellenza
						case 8: // Promozione
						case 9: // PrimaCategoria
						case 10: // SecondaCategoria
						case 11: // TerzaCategoria
							return category - 1;
						default:
							return 11;
					}
				}
			}
			function getCategoryByAge(age) {
				switch (age) {
					case 6:
					case 7:
					case 8:
						return 26; //'Primi Calci / Piccoli Amici';
					case 9:
					case 10:
						return 27; //'Pulcini';
					case 11:
					case 12:
						return 28; //'Esordienti';
					case 13:
					case 14:
						return 22; //'Giovanissimi Elite';
					case 15:
					case 16:
						return 18; //'Allievi';
					case 17:
						return 12; //'Juniores Elite';
					case 18:
						return 5; //'Berretti';
					case 19:
					case 20:
						return 3; //'Primavera 1';
					default:
						return -1;
				}
			}
			function getSimulatedCategory(
				age,
				firstExperience,
				lastExperience,
				position
			) {
				// past experiences
				if (position < 3) {
					if (
						self.commonService.isYouthSection(
							firstExperience,
							self.isTransferPlayer
						) ||
						age <= 20
					)
						return self.isTransferPlayer
							? self.commonService.getYouthSectionId(
									self.isTransferPlayer
							  )
							: getCategoryByAge(age);
					else {
						// first past experience
						if (position == 2)
							return getPreviousFirstTeamCategory(
								getPreviousFirstTeamCategory(
									firstExperience,
									age
								)
							);
						// two previous categories
						else
							return getPreviousFirstTeamCategory(
								firstExperience,
								age
							);
					}
					// future experiences
				} else {
					if (
						self.commonService.isYouthSection(
							lastExperience,
							self.isTransferPlayer
						)
					) {
						if (age <= 20)
							return self.isTransferPlayer
								? self.commonService.getYouthSectionId(
										self.isTransferPlayer
								  )
								: getCategoryByAge(age);
						else {
							// third tier / serie C
							if (position == 3 || position == 4) return 2;
							else return age == 21 ? 2 : 1; // third tier, second tier / siere C, serie B
						}
					} else {
						if (age < 30) {
							if (position == 3 || position == 4) {
								if (
									self.playerData.Experiences[0].Season
										.EndYear ==
									new Date().getFullYear() - 1
								)
									// the last season was without team
									return lastExperience;
								else
									return getFutureFirstTeamCategory(
										lastExperience
									); // one future category
							} else {
								if (
									self.playerData.Experiences[0].Season
										.EndYear ==
									new Date().getFullYear() - 1
								)
									// the last season was without team
									return getFutureFirstTeamCategory(
										lastExperience
									);
								else
									return getFutureFirstTeamCategory(
										getFutureFirstTeamCategory(
											lastExperience
										)
									); // two future categories
							}
						} else {
							// final destiny: retirement
							if (position == 3) return lastExperience;
							else {
								if (age == 30) return lastExperience;
								else
									return getPreviousFirstTeamCategory(
										lastExperience
									);
							}
						}
					}
				}
			}
			function simulateCategories(firstExperience, lastExperience) {
				var simulatedCategories = [];
				var category = null;

				// past simulated experiences
				for (let i = 0; i < 3; i++) {
					category = getSimulatedCategory(
						self.playerAge - 3 - i,
						firstExperience,
						lastExperience,
						i
					);
					simulatedCategories.splice(0, 0, category);
				}

				// future simulated experiences
				for (let i = 0; i < 3; i++) {
					category = getSimulatedCategory(
						self.playerAge + 1 + i,
						firstExperience,
						lastExperience,
						i + 3
					);
					simulatedCategories.push(category);
				}

				return simulatedCategories;
			}
			function getCategoryCoeff(category, age, role) {
				var coeffRole = 0;
				var coeffAge = 0;
				var coeffCategory = 0;

				switch (role) {
					case 1:
						coeffRole = 0.5;
						break;
					case 2:
					case 3:
					case 4:
					case 5:
						coeffRole = 0.7;
						break;
					case 6:
					case 7:
					case 8:
					case 9:
						coeffRole = 0.8;
						break;
					case 10:
					case 11:
						coeffRole = 1;
						break;
					default:
						coeffRole = 0;
						break;
				}

				switch (age) {
					case 7:
					case 8:
						coeffAge = 0.1;
						break;
					case 9:
					case 10:
						coeffAge = 0.15;
						break;
					case 11:
					case 12:
						coeffAge = 0.3;
						break;
					case 13:
					case 14:
						coeffAge = 0.3;
						break;
					case 15:
						coeffAge = 0.6;
						break;
					case 16:
						coeffAge = 0.7;
						break;
					case 17:
						coeffAge = 0.9;
						break;
					case 18:
						coeffAge = 0.85;
						break;
					case 19:
						coeffAge = 0.825;
						break;
					case 20:
						coeffAge = 0.8;
						break;
					case 21:
						coeffAge = 0.775;
						break;
					case 22:
						coeffAge = 0.75;
						break;
					case 23:
						coeffAge = 0.725;
						break;
					case 24:
						coeffAge = 0.7;
						break;
					case 25:
						coeffAge = 0.675;
						break;
					case 26:
						coeffAge = 0.65;
						break;
					case 27:
						coeffAge = 0.625;
						break;
					case 28:
						coeffAge = 0.6;
						break;
					case 29:
						coeffAge = 0.575;
						break;
					case 30:
						coeffAge = 0.55;
						break;
					case 31:
						coeffAge = 0.525;
						break;
					case 32:
						coeffAge = 0.5;
						break;
					case 33:
						coeffAge = 0.475;
						break;
					case 34:
						coeffAge = 0.45;
						break;
					case 35:
						coeffAge = 0.425;
						break;
					case 36:
						coeffAge = 0.4;
						break;
					case 37:
						coeffAge = 0.375;
						break;
					case 38:
						coeffAge = 0.35;
						break;
					case 39:
						coeffAge = 0.325;
						break;
					default:
						coeffAge = 0;
						break;
				}

				if (self.isTransferPlayer) {
					switch (category) {
						case 0:
							coeffCategory = 1;
							break;
						case 1:
							coeffCategory = 0.9;
							break;
						case 2:
							coeffCategory = 0.8;
							break;
						case 3:
							coeffCategory = 0.7;
							break;
						case 4:
							coeffCategory = 0.55;
							break;
						case 5:
							coeffCategory = 0.5;
							break;
						case 6:
							coeffCategory = 0.4;
							break;
						case 7:
							coeffCategory = 0.3;
							break;
						case 8:
							coeffCategory = 0.2;
							break;
						case 9:
						case 10:
						case 11:
						case 12:
						case 13:
						case 14:
							coeffCategory = 0.1;
							break;
						case 15:
							if (age == 20 || age == 19 || age == 18)
								coeffCategory = 0.65;
							else if (age == 17) coeffCategory = 0.6;
							else if (age == 16) coeffCategory = 0.5;
							else if (age == 15) coeffCategory = 0.4;
							else if (age == 14) coeffCategory = 0.3;
							else if (age < 14) coeffCategory = 0.2;
							else coeffCategory = 0;
							break;
						default:
							coeffCategory = 0;
							break;
					}
				} else {
					switch (category) {
						case 0: //'Serie A';
							coeffCategory = 1;
							break;
						case 1: //'Serie B';
							coeffCategory = 0.9;
							break;
						case 2: //'Serie C';
							coeffCategory = 0.8;
							break;
						case 3: //'Primavera 1';
						case 4: //'Primavera 2';
							coeffCategory = 0.65;
							break;
						case 5: //'Berretti';
							coeffCategory = 0.6;
							break;
						case 6: //'Serie D';
							coeffCategory = 0.7;
							break;
						case 7: //'Eccellenza';
							coeffCategory = 0.55;
							break;
						case 8: //'Promozione';
							coeffCategory = 0.5;
							break;
						case 9: //'Prima Categoria';
							coeffCategory = 0.4;
							break;
						case 10: //'Seconda Categoria';
							coeffCategory = 0.3;
							break;
						case 11: //'Terza Categoria';
							coeffCategory = 0.2;
							break;
						case 12: //'Juniores Elite';
						case 13: //'Juniores Nazionali';
						case 14: //'Juniores Regionali';
						case 15: //'Juniores Provinciali';
						case 16: //'Under 18 Serie A';
						case 17: //'Under 18 Serie B';
							coeffCategory = 0.4;
							break;
						case 18: //'Allievi Elite';
						case 19: //'Allievi Nazionali';
						case 20: //'Allievi Regionali';
						case 21: //'Allievi Provinciali';
							coeffCategory = 0.3;
							break;
						case 22: //'Giovanissimi Elite';
						case 23: //'Giovanissimi Nazionali';
						case 24: //'Giovanissimi Regionali';
						case 25: //'Giovanissimi Provinciali';
							coeffCategory = 0.2;
							break;
						case 26: //'Primi Calci / Piccoli Amici';
						case 27: //'Pulcini';
						case 28: //'Esordienti';
							coeffCategory = 0.1;
							break;
						default:
							coeffCategory = 0;
							break;
					}
				}

				return coeffRole * coeffAge * coeffCategory;
			}
			function getCategoryColor(categoryId) {
				switch (categoryId) {
					case 0:
						return "#001a33";
					case 1:
						return "#00264d";
					case 2:
						return "#003366";
					case 3:
						return "#004080";
					case 4:
						return "#004d99";
					case 5:
						return "#0059b3";
					case 6:
						return "#0066cc";
					case 7:
						return "#0073e6";
					case 8:
						return "#0080ff";
					case 9:
						return "#1a8cff";
					case 10:
						return "#3399ff";
					case 11:
						return "#4da6ff";
					case 12:
						return "#66b3ff";
					case 13:
						return "#80bfff";
					case 14:
						return "#99ccff";
					case 15:
					default:
						return "#b3d9ff";
				}
			}
			function getCategoryLogo(category) {
				switch (category) {
					case 0: //'Serie A';
						return logoSerieA;
					case 1: //'Serie B';
						return logoSerieB;
					case 2: //'Serie C';
						return logoSerieC;
					case 3: //'Primavera 1';
					case 4: //'Primavera 2';
						return logoPrimavera;
					case 5: //'Berretti';
					case 12: //'Juniores Elite';
					case 13: //'Juniores Nazionali';
					case 14: //'Juniores Regionali';
					case 15: //'Juniores Provinciali';
					case 18: //'Allievi Elite';
					case 19: //'Allievi Nazionali';
					case 20: //'Allievi Regionali';
					case 21: //'Allievi Provinciali';
					case 22: //'Giovanissimi Elite';
					case 23: //'Giovanissimi Nazionali';
					case 24: //'Giovanissimi Regionali';
					case 25: //'Giovanissimi Provinciali';
					case 16: //'Under 18 Serie A';
					case 17: //'Under 18 Serie B';
						return logoSettoreGiovanile;
					case 6: //'Serie D';
						return logoSerieD;
					case 7: //'Eccellenza';
					case 8: //'Promozione';
					case 9: //'Prima Categoria';
					case 10: //'Seconda Categoria';
					case 11: //'Terza Categoria';
						return logoLND;
					case 26: //'Primi Calci / Piccoli Amici';
					case 27: //'Pulcini';
					case 28: //'Esordienti';
						return logoSettoreGiovanile;
					default:
						return 0;
				}
			}
			function getCategoryName(category) {
				if (self.isTransferPlayer) {
					return self.enumService.getEnumName(
						self.enumService.getCategoryLevelEnum(),
						category
					);
				} else {
					switch (category) {
						case 0:
							return "Serie A";
						case 1:
							return "Serie B";
						case 2:
							return "Serie C";
						case 3: //'Primavera 1';
						case 4: //'Primavera 2';
							return "Primavera";
						case 5:
							return "Berretti";
						case 12: //'Juniores Elite';
						case 13: //'Juniores Nazionali';
						case 14: //'Juniores Regionali';
						case 15: //'Juniores Provinciali';
							return "Juniores";
						case 18: //'Allievi Elite';
						case 19: //'Allievi Nazionali';
						case 20: //'Allievi Regionali';
						case 21: //'Allievi Provinciali';
							return "Allievi";
						case 22: //'Giovanissimi Elite';
						case 23: //'Giovanissimi Nazionali';
						case 24: //'Giovanissimi Regionali';
						case 25: //'Giovanissimi Provinciali';
							return "Giovanissimi";
						case 16: //'Under 18 Serie A';
						case 17: //'Under 18 Serie B';
							return "Under 18";
						case 6:
							return "Serie D";
						case 7:
							return "Eccellenza";
						case 8:
							return "Promozione";
						case 9:
							return "1º Categoria";
						case 10:
							return "2º Categoria";
						case 11:
							return "3º Categoria";
						case 26:
							return "Primi Calci / Piccoli Amici";
						case 27:
							return "Pulcini";
						case 28:
							return "Esordienti";
						default:
							return 0;
					}
				}
			}
			function generateRowValues() {
				var simulatedCategories = simulateCategories(
					self.playerData.Experiences[2].Division,
					self.playerData.Experiences[0].Division
				);
				var initialPastExperiencesAge = self.playerAge - 5;
				var initialExperiencesAge = self.playerAge - 2;
				var initialFutureExperiencesAge = self.playerAge + 1;

				// simulated experiences
				for (let i = 0; i < 6; i++) {
					let currentAge =
						i <= 2
							? initialPastExperiencesAge++
							: initialFutureExperiencesAge++;
					let coeff = getCategoryCoeff(
						simulatedCategories[i],
						currentAge,
						self.playerData.Roles[0].RoleEnumId
					);
					if (coeff > self.y_max) self.y_max = coeff;

					let graphRow = {
						category: simulatedCategories[i],
						categoryName: getCategoryName(simulatedCategories[i]),
						categoryCoeff: coeff,
						categoryColor: getCategoryColor(simulatedCategories[i]),
						categoryLogo: getCategoryLogo(simulatedCategories[i]),
						teamName: "",
						playerAge: currentAge
					};
					self.graphRows.push(graphRow);
				}

				// real experiences
				for (let i = 2; i >= 0; i--) {
					let currentAge = initialExperiencesAge++;
					let coeff = getCategoryCoeff(
						self.playerData.Experiences[i].Division,
						currentAge,
						self.playerData.Roles[0].RoleEnumId
					);
					if (i == 2) self.y_experiences_tag = coeff;
					if (coeff > self.y_max) self.y_max = coeff;

					let graphRow = {
						category: self.playerData.Experiences[i].Division,
						categoryName: getCategoryName(
							self.playerData.Experiences[i].Division
						),
						categoryCoeff: coeff,
						categoryColor: getCategoryColor(
							self.playerData.Experiences[i].Division
						),
						categoryLogo: getCategoryLogo(
							self.playerData.Experiences[i].Division
						),
						teamName: self.playerData.Experiences[i].TeamName,
						playerAge: currentAge
					};
					self.graphRows.splice(3 + (2 - i), 0, graphRow);
				}

				self.y_max += self.y_max_offset;
			}
			function generatePoints() {
				for (var i = 0; i < 9; i++) {
					let serieIndex;
					if (i <= 2) serieIndex = 0;
					else if (i <= 5) serieIndex = 1;
					else serieIndex = 2;

					let point = {};
					if (self.isTransferPlayer) {
						point = {
							x: self.xAxisLabels[i],
							seriesIndex: serieIndex,
							marker: {
								size: 6,
								fillColor: "#fff",
								strokeColor: "red",
								radius: 2,
								cssClass: "apexcharts-custom-class"
							},
							label: {
								borderColor: self.graphRows[i].categoryColor,
								offsetY: 0,
								style: {
									color: "#fff",
									background: self.graphRows[i].categoryColor
								},
								text: self.graphRows[i].categoryName
							}
						};
					} else {
						point = {
							x: self.xAxisLabels[i],
							seriesIndex: serieIndex,
							image: {
								path: self.graphRows[i].categoryLogo,
								offsetX: 0,
								offsetY: 15,
								width:
									window.innerWidth >= 1300 &&
									window.innerWidth < 1500
										? 40
										: 50,
								height:
									window.innerWidth >= 1300 &&
									window.innerWidth < 1500
										? 40
										: 50
							}
						};
					}
					self.points.push(point);
				}
			}

			let self = this;
			self.playerAge = this.commonService.getAge(
				self.playerData.BornDate
			);
			self.numberExperiencies =
				self.playerData.Experiences != null
					? self.playerData.Experiences.length == 0
						? 1
						: self.playerData.Experiences.length
					: 0;

			// check if user has the experience for the last 3 seasons
			if (
				!this.commonService.checkChartValidExperiences(
					this.playerData.Experiences
				)
			) {
				this.chartGenerated = false;
				return;
			}

			generateXAxisLabels();
			generateRowValues();
			generateSeries();
			generatePoints();

			this.chartOptions = {
				chart: {
					animations: {
						enabled: false
					},
					height: 350,
					type: "line",
					id: "canvas-model",
					background: "#fff",
					toolbar: {
						tools: {
							download: false,
							pan: false
						}
					}
				},
				annotations: {
					yaxis: [],
					xaxis: [
						{
							x: this.annotations_xaxis_x,
							x2: this.annotations_xaxis_x2,
							fillColor: "grey",
							opacity: 0.4,
							label: {
								borderColor: "#B3F7CA",
								style: {
									fontSize: "10px",
									color: "#fff",
									background: "#00E396"
								},
								offsetY:
									this.y_max -
										this.y_max_offset -
										this.y_experiences_tag >
									this.y_experiences_tag - this.y_min
										? 15
										: 140,
								text: this.$t("Experience")
							}
						}
					],
					points: self.points
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					curve: "smooth",
					dashArray: [0, 0, 10],
					width: [2, 5, 1],
					colors: ["#000"]
				},
				legend: {
					show: false
				},
				tooltip: {
					followCursor: true, // false
					shared: true, // false
					custom: function({
						series,
						seriesIndex,
						dataPointIndex,
						w
					}) {
						if (dataPointIndex >= 3 && dataPointIndex <= 5) {
							return (
								'<div style="padding:10px;text-align:left;">' +
								'<p style="font-size:12px;color:#505050"><b style="font-weight:bold">' +
								self.$t("Club") +
								": </b>" +
								self.graphRows[dataPointIndex].teamName +
								"</p>" +
								'<p style="font-size:12px;color:#505050"><b style="font-weight:bold">' +
								self.$t("Category") +
								": </b>" +
								self.graphRows[dataPointIndex].categoryName +
								"</p>" +
								'<p style="font-size:12px;color:#505050"><b style="font-weight:bold">' +
								self.$t("Age") +
								": </b>" +
								self.graphRows[dataPointIndex].playerAge +
								"</p>" +
								"</div>"
							);
						} else {
							return (
								'<div style="padding:10px;text-align:left;">' +
								'<p style="font-size:12px;color:#505050"><b style="font-weight:bold">' +
								self.$t("PotentialCategory") +
								": </b>" +
								self.graphRows[dataPointIndex].categoryName +
								"</p>" +
								'<p style="font-size:12px;color:#505050"><b style="font-weight:bold">' +
								self.$t("Age") +
								": </b>" +
								self.graphRows[dataPointIndex].playerAge +
								"</p>" +
								"</div>"
							);
						}
					}
				},
				grid: {
					show: false,
					padding: {
						right: 20,
						left: 20
					}
				},
				title: {
					text: "",
					align: "left",
					style: {
						fontSize: "14px",
						fontWeight: "bold",
						fontFamily: undefined,
						color: "black"
					}
				},
				xaxis: {
					type: "category",
					categories: this.xAxisLabels,
					labels: {
						style: {
							colors: [
								"black",
								"black",
								"black",
								"black",
								"black",
								"black",
								"black",
								"black",
								"black",
								"black",
								"black",
								"black"
							],
							fontSize: "12px",
							fontFamily: "Helvetica, Arial, sans-serif",
							fontWeight: 400,
							cssClass: "apexcharts-xaxis-label"
						}
					}
				},
				yaxis: {
					show: false,
					min: this.y_min,
					max: this.y_max
				}
			};

			this.chartGenerated = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.error-box {
	border: 1px solid #b3c2ca;
	height: 320px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>